import { NumberFormatType } from "@/core/types/number.type";
import { NumberFormatterService } from "@/core/services";
import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";
import { AccountingLinkedCheck, AccountingLinkedCheckProps } from "./AccountingLinkedCheck";

export interface AccountingSystemInvoiceProps {
    externalInvoiceId: number;
    externalInvoiceDocumentNumber: string;
    externalInvoiceCustomerId: number;
    externalInvoiceOpenBalance: number;
    externalInvoiceDate: string;
    deductionPurchaserKey: string;
    deductionPurchaserName: string;
    linkedChecks?: AccountingLinkedCheckProps[];
}

export class AccountingSystemInvoice implements AccountingSystemInvoiceProps {
    private readonly _deductionPurchaserKey: string;
    private readonly _deductionPurchaserName: string;
    private readonly _externalInvoiceId: number;
    private readonly _externalInvoiceDocumentNumber: string;
    private readonly _externalInvoiceCustomerId: number;
    private readonly _externalInvoiceOpenBalance: number;
    private readonly _externalInvoiceDate: string;
    private readonly _linkedChecks: AccountingLinkedCheck[];

    constructor(props: AccountingSystemInvoiceProps) {
        this._externalInvoiceId = props.externalInvoiceId;
        this._externalInvoiceDocumentNumber = props.externalInvoiceDocumentNumber;
        this._externalInvoiceCustomerId = props.externalInvoiceCustomerId;
        this._externalInvoiceOpenBalance = props.externalInvoiceOpenBalance;
        this._externalInvoiceDate = props.externalInvoiceDate;
        this._deductionPurchaserKey = props.deductionPurchaserKey;
        this._deductionPurchaserName = props.deductionPurchaserName;
        this._linkedChecks = (props.linkedChecks ?? []).map(check => AccountingLinkedCheck.fromJson(check));
    }

    public get externalInvoiceId(): number {
        return this._externalInvoiceId;
    }

    public get externalInvoiceDocumentNumber(): string {
        return this._externalInvoiceDocumentNumber;
    }

    public get externalInvoiceCustomerId(): number {
        return this._externalInvoiceCustomerId;
    }

    public get externalInvoiceOpenBalance(): number {
        return this._externalInvoiceOpenBalance;
    }

    public externalInvoiceOpenBalanceFormatted(format: NumberFormatType): string {
        return this._externalInvoiceOpenBalance ? new NumberFormatterService(new NumberFormatterAdapter()).format(this._externalInvoiceOpenBalance, format) : "";
    }

    public get externalInvoiceDate(): string {
        return this._externalInvoiceDate;
    }

    public get deductionPurchaserKey(): string {
        return this._deductionPurchaserKey;
    }

    public get deductionPurchaserName(): string {
        return this._deductionPurchaserName;
    }

    public get linkedChecks(): AccountingLinkedCheck[] {
        return this._linkedChecks;
    }
}